module.exports = __webpack_public_path__ + "static/media/Mueller_dark_logo.1670ebac.svg";